import PropTypes from 'prop-types';
import React from 'react';
import { FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import RequirableControlLabel from '../RequirableControlLabel/RequirableControlLabel';
import './TTFormGroup.css';

const isError = (error, touched) => (error && touched ? 'error' : null);

// eslint-disable-next-line object-curly-newline
const TTFormGroup = ({ label, meta, input, required, ...props }) => (
  <FormGroup validationState={isError(meta.error, meta.touched)} >
    {label && <RequirableControlLabel required={required} >{label}</RequirableControlLabel> }
    <FormControl {...input} {...props} />
    <FormControl.Feedback />
    {(meta.touched && meta.error) && <HelpBlock>{meta.error}</HelpBlock> }
  </FormGroup>
);

TTFormGroup.defaultProps = {
  label: '',
  meta: {},
  input: {},
  required: false,
};

TTFormGroup.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  meta: PropTypes.shape({}),
  input: PropTypes.shape({}),
};

export default TTFormGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/TTFormGroup/TTFormGroup.jsx